var $menuIcon = $('header .menu-wrapper .menu-button');
var $header = $('header');
var $body = $('body');
let $removeBg = $('remove-bg');
let $menuText = document.getElementById('menu-text');

var $navMenu = $('header .menu-wrapper .nav-menu');

if ($menuIcon) {
    $menuIcon.click(function () {
        if ($menuIcon.hasClass('menu-open')) {
            $menuIcon.removeClass('menu-open');
            $header.removeClass('show-menu');
            $body.removeClass('no-scroll-y');
            $menuText.textContent = 'Meny';
            if ($header.hasClass('remove-bg')) {
                $header.removeClass('bg-blue');
            }
            $navMenu.css({
                'max-height': '0'
            })
        } else {
            $menuIcon.addClass('menu-open');
            $header.addClass('show-menu');
            $header.addClass('bg-blue');
            $body.addClass('no-scroll-y');
            $menuText.textContent = 'Lukk';
            $navMenu.css({
                'max-height': ('calc(var(--vh, 1vh) * 100)')
            })
        }
    });
}

$(window).resize(function () {
    if ($(window).width() >= 1200) {
        $('header').removeClass('show-menu');
    }
});

var $childrenMenuLink = $('header .menu-wrapper .nav-menu .menu-content ul li.menu-item-has-children .link-wrapper >a');
var $submenuArrow = $('header .menu-wrapper .nav-menu .menu-content ul li.menu-item-has-children .submenu-arrow');
var $submenuLink = $('header .menu-wrapper .nav-menu .menu-content ul li.menu-item-has-children ul.submenu li a');

if ($(window).width() < 1200) {
    $childrenMenuLink.click(function (e) {
        e.preventDefault();
        if ($(this).closest('li').hasClass('submenu-open')) {
            $(this).closest('li').removeClass('submenu-open');
            window.location = $(this).attr('href');
        } else {
            $(this).closest('li').addClass('submenu-open');
        }
    });

    $submenuArrow.click(function (e) {
        if ($(this).closest('li').hasClass('submenu-open')) {
            $(this).closest('li').removeClass('submenu-open');
        } else {
            $(this).closest('li').addClass('submenu-open');
        }
    });

    $submenuLink.click(function (e) {
        $(this).parent().removeClass('submenu-open');
        $menuIcon.removeClass('menu-open');
        $header.removeClass('show-menu');
        $body.removeClass('no-scroll-y');
    });
}